export const slug = "reports";
export const title = "Reports";
export const section = "Core";
export const content = `
# Reports

The Reports page gives you data-driven insights into your food bank's operations.

## Pounds of Food Chart

The **Pounds of Food** chart tracks estimated food distributed per week based on visit counts and average item weights configured in Settings. Use the date-range picker to zoom in on a specific period.

## Seasonal Program Stats

When Sharing Tree or another seasonal program is active, a dedicated section shows:

- Total households enrolled
- Vouchers issued vs. redeemed
- Breakdown by tier (e.g., 1–2 members, 3–4 members, 5+)

## Household Retention

The **Retention** chart shows what percentage of clients who visited in one month returned the following month. A sudden drop can indicate a service disruption or community event worth investigating.

## Exporting Reports

Every chart and table on the Reports page has an **Export CSV** button. The CSV includes all the underlying data for that view, formatted for import into Excel or Google Sheets.

## Tips

- Reports reflect **completed visits** only; clients currently in the Saturday queue are not included until their visit is marked Done.
- Changing the date range on one chart does not affect other charts — each range is independent.
- If you notice a data anomaly, check the Audit Log for recent bulk imports or manual visit edits that may explain the spike or dip.
`;
